import { Base } from "@studiometa/js-toolkit";
class Loader extends Base {
  mounted() {
    setTimeout(() => {
      this.$el.classList.add("begin");
      document.querySelector("body").classList.add("show");
      setTimeout(() => {
        this.$el.classList.add("out");
        this.$destroy();
        setTimeout(() => {
          this.$el.remove();
        }, 1e3);
      }, 3e3);
    }, 500);
  }
}
Loader.config = {
  name: "Loader",
  refs: ["macaron"]
};
export {
  Loader as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
